import React, { useState } from "react";
import { Button } from "antd";
import { ReactSVG } from "react-svg";
import { filter, isEmpty } from "lodash";

import "./index.scss";
import DriverHeader from "./DriverHeader";
import DriverList from "./DriverList";
import { getTranslation } from "../../utils/helper";
import { getDriverIds } from "../RouteChart/Utils";

const RouteDispatch = ({
  routePlan,
  routes,
  setChartType,
  driverIdsHide,
  setDriverIdsHide,
  doLockDriver,
  handleUpdateDriver,
  reloadData,
  setting,
}) => {
  const [driverIdsLock, setDriverIdsLock] = useState([]);
  const dispatched = filter(routes, r => r.status === "DISPATCHED").length;
  const waiting = filter(routes, r => r.status !== "DISPATCHED").length;
  const missingPhone = filter(routes, r => isEmpty(r.driver.phone)).length;

  const onClickHide = driverId => {
    const driverIds = getDriverIds(routes, driverIdsHide, driverId);
    setDriverIdsHide(driverIds);
  };

  const onClickLock = driverId => {
    const driverIds = getDriverIds(routes, driverIdsLock, driverId);
    setDriverIdsLock(driverIds);
    doLockDriver({
      id: routePlan._id,
      driver: driverId !== "all-drivers" ? driverId : undefined,
      locked: driverIds.includes(driverId),
    });
  };

  const handleSubmit = params => {
    handleUpdateDriver(params);
    setTimeout(() => {
      reloadData();
    }, 200);
  };

  return (
    <div className="route-chart-content route-chart-content-dispatch">
      <div className="header">
        <div className="left">
          <Button className="btn-timeline" onClick={() => setChartType("timeline")}>
            {getTranslation(setting, "Route Plans", "Timeline")}
            <ReactSVG className="icon" src="/icons/timeline.svg" />
          </Button>
          <Button className="btn-dispatch active" onClick={() => setChartType("dispatch")}>
            {getTranslation(setting, "Route Plans", "Dispatch")}
            <ReactSVG className="icon" src="/icons/dispatch.svg" />
          </Button>
        </div>
      </div>
      <div className="content">
        <div
          className="tbody"
          style={{
            overflow: "scroll",
            height: "194px",
          }}>
          <DriverHeader
            driverIdsLock={driverIdsLock}
            driverIdsHide={driverIdsHide}
            onClickLock={onClickLock}
            onClickHide={onClickHide}
            setting={setting}
          />
          <DriverList
            routes={routes}
            driverIdsLock={driverIdsLock}
            driverIdsHide={driverIdsHide}
            onClickLock={onClickLock}
            onClickHide={onClickHide}
            handleSubmit={handleSubmit}
            setting={setting}
          />
        </div>
      </div>
      <div className="footer">
        <div className="left">
          <div className="item">
            <b>{waiting}</b> {getTranslation(setting, "Route Plans", "Waiting to dispatch")}
          </div>
          <div className="item">
            <b>{missingPhone}</b> {getTranslation(setting, "Route Plans", "Missing phone number")}
          </div>
          <div className="item">
            <b>{dispatched}</b> {getTranslation(setting, "Route Plans", "DISPATCHED")}
          </div>
        </div>
        <div className="right"></div>
      </div>
    </div>
  );
};

export default RouteDispatch;
